import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import tokens from '@te-digi/styleguide-tokens';
import { Text } from '../Text/Text.js';
import { media } from '../utils/styles/media.js';

const getAlignStyle = align => {
  if (typeof align === 'object') {
    return Object.keys(align).map(breakpoint => breakpoint === 'xs' ? "text-align: ".concat(align, ";") : "".concat(media[breakpoint], " { text-align: ").concat(align, "; }")).join('\n');
  } else if (typeof align === 'string') {
    return "text-align: ".concat(align, ";");
  } else {
    return;
  }
};
const StyledText = styled(props => /*#__PURE__*/React__default.createElement(Text, _extends({
  as: "p"
}, props))).withConfig({
  componentId: "sg1510__sc-1yh7zjs-0"
})(["margin-bottom:", ";", ""], props => !props.noMargin && tokens.space.lg, props => getAlignStyle(props.align));
const Paragraph = _ref => {
  let {
    align,
    children,
    className,
    id,
    noMargin,
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default.createElement(StyledText, _extends({
    align: align,
    className: className,
    id: id,
    noMargin: noMargin
  }, rest), children);
};
const TEXT_ALIGN = ['left', 'center', 'right'];
Paragraph.displayName = 'Paragraph';
Paragraph.propTypes = {
  align: PropTypes.oneOfType([PropTypes.oneOf(TEXT_ALIGN), PropTypes.shape({
    xs: PropTypes.oneOf(TEXT_ALIGN),
    sm: PropTypes.oneOf(TEXT_ALIGN),
    md: PropTypes.oneOf(TEXT_ALIGN),
    lg: PropTypes.oneOf(TEXT_ALIGN),
    xl: PropTypes.oneOf(TEXT_ALIGN)
  })]),
  /**
   * Text content of the component.
   */
  children: PropTypes.node,
  className: PropTypes.string,
  id: PropTypes.string,
  /**
   * Disable default bottom margin.
   */
  noMargin: PropTypes.bool
};

export { Paragraph };
